import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { IndexComponent } from './index/index.component';
import { Shell } from './../shell/shell.service';
import { AuthGuard } from '../core/authentication/auth.guard';

const routes: Routes = [
  Shell.childRoutes([
    { path: '', component: IndexComponent, canActivate: [AuthGuard], data: { forAdmin: false } },
    { path: 'home', component: IndexComponent }
  ])
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class HomeRoutingModule { }
